module.exports = __webpack_public_path__ + "img/05 Aniamtion 3-squashed.717c6423.jpg";